export { ENCODE_NAME_PREFIX } from '@module-federation/sdk';

const FEDERATION_SUPPORTED_TYPES = [
    'script'
];

export { FEDERATION_SUPPORTED_TYPES };
